import React, { useState } from "react";
import { RxCross1 } from "react-icons/rx";
import { toast } from "react-toastify";
import { FaDownload } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { getSubscriptionReport, uploadSubscriptionReport } from "../../../redux/slices/sidekickuserSlice";

export default function UploadSubscriptionFilePopup({ onClose, fetchUsers }) {
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [downloading, setDownloading] = useState(false);


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const allowedTypes = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];

        if (file && allowedTypes.includes(file.type)) {
            setSelectedFile(file);
        } else {
            toast.error("Please select a valid Excel file (.xls or .xlsx)");
            e.target.value = null;
            setSelectedFile(null);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a file first");
            return;
        }

        setUploading(true);

        try {
            const formData = new FormData();
            formData.append("excelFile", selectedFile);

            const resultAction = await dispatch(uploadSubscriptionReport(formData));
            if (resultAction?.payload?.code === 200) {
                onClose();
                fetchUsers();
                toast.success(resultAction?.payload?.message);
            } else {
                toast.error(resultAction?.payload?.response?.data?.message || "Failed to upload file");
            }
        } catch (error) {
            toast.error("Error uploading file");
        } finally {
            setUploading(false);
        }
    };

    const handleDownloadSample = async () => {
        setDownloading(true);
        try {
            const resultAction = await dispatch(getSubscriptionReport());

            if (getSubscriptionReport.fulfilled.match(resultAction)) {
                const blob = resultAction.payload;
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Sample_Subscription_Upload.xlsx");
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);

                toast.success("Sample report download started");
            } else {
                toast.error("Failed to download sample report");
            }
        } catch (error) {
            toast.error("Something went wrong while downloading sample");
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="relative bg-[#150c3f] p-6 rounded-lg w-full max-w-[460px] text-center">
                <button
                    className="absolute top-4 right-4 text-white text-xl"
                    onClick={onClose}
                    aria-label="Close popup"
                    disabled={uploading || downloading}
                >
                    <RxCross1 />
                </button>

                <h2 className="text-white text-2xl mb-4">Reward Customers with a Gift Subscription</h2>

                <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                    className="bg-[#372F5B] text-white p-2 rounded w-full mb-4"
                    disabled={uploading}
                />

                <div className="flex justify-center gap-4 mt-2">
                    <button
                        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={handleUpload}
                        type="button"
                        disabled={uploading}
                    >
                        {uploading ? "Rewarding..." : "Reward Customers"}
                    </button>
                    <button
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={handleDownloadSample}
                        type="button"
                        disabled={downloading}
                    >
                        <FaDownload />
                        {downloading ? "Downloading..." : "Sample Report"}
                    </button>
                </div>
            </div>
        </div>
    );
}